import { render } from "./errorPage1.vue?vue&type=template&id=54fbe9e8&scoped=true"
const script = {}

import "./errorPage1.vue?vue&type=style&index=0&id=54fbe9e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fbe9e8"]])

export default __exports__